import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ggi-10",
  "use": "icon-ggi-10-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ggi-10\">\n<rect x=\"4\" y=\"6\" width=\"16\" height=\"11\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\" />\n<rect x=\"15\" y=\"19\" width=\"2\" height=\"6\" rx=\"1\" transform=\"rotate(90 15 19)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol